<modal #memberRestrictionModal [closeOnEscape]="false" [closeOnOutsideClick]="false" >
    <modal-header>
        <div class="color-blue">{{'customer-service.ACCOUNT NOTIFICATION' |translate}}</div>
    </modal-header>
    <modal-content *ngIf="memberDetails">
        <div class="distributorInfo">
            <div class="bold">
                <span> {{memberDetails.firstName}} {{memberDetails.lastName}}</span>
              </div>
            <div> 
                <a><i class="fa fa-copy" [copyToClipboard]="memberDetails.fboId" ></i></a>
                <span>{{memberDetails.fboId | distributorIdFormat}} </span>
                <span *ngIf="memberDetails.memberLevel"> | </span>
                <span>{{memberDetails.memberLevel }}</span>
            </div>
        </div>
        <div class="accountNotification-content modalcontent-section">
            <div class="notificationSubject">
                <span>{{'customer-service.Restricted'|translate}}</span>
            </div>
            <div class="mt-20">
               {{'customer-service.This account is currently marked as Restricted and cannot be accessed. Please contact your country office VP for additional information.'|translate}}
            </div>
        </div>
        <div class="pull-right pad-r-8">
            <button class="btn blue-button" tabindex="0" type="button"
                (click)="closememberRestrictionModal()">
                {{'customer-service.OK' |translate}}
            </button>
        </div>
    </modal-content>
</modal>




// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/account-restriction-popup.component.html